class ProducerList extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-producer-swiper]');
        this.swiper = null;
        if (this.swiperEl) {
            this.constructSwiper();
        }
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            watchOverflow: true,
            slidesPerView: 2,
            spaceBetween: 30,
            loop: true,
            breakpoints: {
                500: {
                    slidesPerView: 3,
                },
                1100: {
                    slidesPerView: 5,
                }
            },
            freeMode: true,
            freeModeSticky: true,
            mousewheel: true,
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const producersEl = document.querySelector('[data-producer-swiper]');
    if (producersEl) {
        new ProducerList(producersEl);
    }
});